import { Selector } from "react-redux";

import type { IAppState } from "@multiweb/types/react";
import type { IComponentRightsState } from "./types";

/**
 * Získá práva pro komponentu se zadaným id. Do komponenty je vhodné předávat pouze ta práva, které komponenta opravdu potřebuje.
 * @param id Identifikátor komponenty.
 * @returns Vrací práva komponenty nebo undefined, pokud komponenta ještě nemá vyhodnocená a nastavená práva.
 * @example Použití
 * const mapStateToProps = (state, { id }) => {
 *     const { enabled, visible } = getComponentRights(state, id) ?? EMPTY_OBJECT; // EMPTY_OBJECT může být nahrazeno za výchozí hodnoty
 *     return {
 *         enabled,
 *         visible,
 *     };
 * };
 */
export const getComponentRights: Selector<IAppState, IComponentRightsState | undefined, string> = (state, id) => {
    return state.rights[id];
};
